export const ApiUpdateSpaceTag = Symbol('ApiUpdateSpaceTag');
